import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "src/hooks/redux";
import { history } from "src/services/history";
import { createInquiryAsync } from "src/redux/myInquiries/actions";
import { InquiryForm } from "src/page-components/cabinet/my-inquiries/InquirySettings/InquiryForm";
import { INQUIRY_SETTINGS_VALIDATION_SCHEMA } from "src/page-components/cabinet/my-inquiries/InquirySettings/constants";
import { inquirySettingsTrns } from "src/page-components/cabinet/my-inquiries/InquirySettings/trns";
import { InquirySettingsValues } from "src/page-components/cabinet/my-inquiries/InquirySettings/types";
import { PageWrapper } from "src/components/Layouts/PageWrapper";
import { getItemPath } from "src/utils/getItemPath";
import { PATHNAMES } from "src/constants/routes";
import { MetadataWrapper } from "src/components/MetadataWrapper";
import { IInquiry } from "src/@types/inquiries";
import { combineSlugId } from "src/utils/combineSlugId";
import { FormikConfig } from "formik";

export const INITIAL_VALUES: InquirySettingsValues = {
  inquiry_type: "",
  title: "",
  industry: "",
  product: "",
  years_on_market: "",
  customers_count: "",
  employees: "",
  inquiry_turnover_min: "" as unknown as number,
  inquiry_turnover_max: "" as unknown as number,
  monthly_income_min: "" as unknown as number,
  monthly_income_max: "" as unknown as number,
  investment_for_start: "" as unknown as number,
  inquiry_cost: "" as unknown as number,
  additional_information: "",
};

const CreateInquiry: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const formikProps: FormikConfig<InquirySettingsValues> = {
    initialValues: INITIAL_VALUES,
    validationSchema: INQUIRY_SETTINGS_VALIDATION_SCHEMA,
    onSubmit: (values, { resetForm }) => {
      const onSuccess = (inquiry: IInquiry) => {
        const combinedSlug = combineSlugId(inquiry.slug, inquiry.id);
        history.push(
          getItemPath(PATHNAMES.INQUIRY_ITEM, { slug: combinedSlug })
        );
        resetForm();
      };

      dispatch(createInquiryAsync({ values, onSuccess }));
    },
  };

  return (
    <MetadataWrapper name="my_inquiries_create">
      <PageWrapper mainClassName="flex flex-col gap-10 py-25">
        <InquiryForm
          title={t(inquirySettingsTrns.title)}
          formikProps={formikProps}
        />
      </PageWrapper>
    </MetadataWrapper>
  );
};

export default CreateInquiry;
